import { defineStore } from 'pinia'
import { ref } from 'vue'
import * as voteApi from '@/api/vote'
import { useUserStore } from '@/stores/user'

export const useVoteStore = defineStore('vote', () => {
    const userStore = useUserStore()
    const voteList = ref([])
    const currentVote = ref(null)
    const userFavorites = ref([])
    const loading = ref(false)

    // 获取投票列表
    async function fetchVoteList() {
        loading.value = true
        try {
            const res = await voteApi.getVoteList()
            voteList.value = res.data || []
        } catch (error) {
            console.error('获取投票列表失败:', error)
            voteList.value = []
            throw error
        } finally {
            loading.value = false
        }
    }

    // 获取投票详情
    async function fetchVoteDetail(id) {
        loading.value = true
        console.log('Store: 开始获取投票详情, ID:', id)
        try {
            const res = await voteApi.getVoteDetail(id)
            console.log('Store: API 返回数据:', res)
            if (!res || !res.data) {
                throw new Error('API 返回数据格式错误')
            }
            currentVote.value = res.data
            console.log('Store: 更新 currentVote:', currentVote.value)
        } catch (error) {
            console.error('Store: 获取投票详情失败:', error)
            currentVote.value = null
            throw error
        } finally {
            loading.value = false
        }
    }

    // 创建投票
    async function createVote(voteData) {
        try {
            const res = await voteApi.createVote(voteData)
            return res.data
        } catch (error) {
            console.error('创建投票失败:', error)
            throw error
        }
    }

    // 投票
    async function castVote(voteId, optionId) {
        if (!userStore.isLoggedIn) {
            throw new Error('请先登录')
        }
        try {
            const res = await voteApi.castVote(voteId, optionId)
            await fetchVoteDetail(voteId)
            return res.data
        } catch (error) {
            console.error('投票失败:', error)
            throw error
        }
    }

    // 收藏/取消收藏
    async function toggleFavorite(voteId) {
        if (!userStore.isLoggedIn) {
            throw new Error('请先登录')
        }
        try {
            const res = await voteApi.toggleFavorite(voteId)
            await fetchUserFavorites()
            return res.data
        } catch (error) {
            console.error('操作收藏失败:', error)
            throw error
        }
    }

    // 获取用户收藏列表
    async function fetchUserFavorites() {
        try {
            if (!userStore.isLoggedIn) {
                userFavorites.value = []
                return
            }
            const res = await voteApi.getUserFavorites()
            userFavorites.value = res.data || []
        } catch (error) {
            console.error('获取收藏列表失败:', error)
            userFavorites.value = []
            throw error
        }
    }

    // 获取用户今日投票次数
    async function getUserVoteCount() {
        try {
            const res = await voteApi.getUserVoteCount()
            return res.data
        } catch (error) {
            console.error('获取投票次数失败:', error)
            throw error
        }
    }

    // 检查是否已收藏
    function isFavorite(voteId) {
        return userFavorites.value.some(vote => vote.id === voteId)
    }

    // 添加评论
    async function addComment(data) {
        try {
            const res = await voteApi.addComment(data)
            return res
        } catch (error) {
            console.error('添加评论失败:', error)
            throw error
        }
    }

    // 添加回复
    async function addReply(commentId, replyData) {
        try {
            const res = await voteApi.addReply(commentId, replyData)
            return res.data
        } catch (error) {
            console.error('添加回复失败:', error)
            throw error
        }
    }


    // 获取评论列表
    async function getComments(voteId) {
        try {
            const res = await voteApi.getComments(voteId)
            return res
        } catch (error) {
            console.error('获取评论列表失败:', error)
            throw error
        }
    }

    return {
        voteList,
        currentVote,
        userFavorites,
        loading,
        fetchVoteList,
        fetchVoteDetail,
        createVote,
        castVote,
        toggleFavorite,
        fetchUserFavorites,
        getUserVoteCount,
        isFavorite,
        addComment,
        addReply,
        getComments
    }
})
